import { render, staticRenderFns } from "./form-employment.vue?vue&type=template&id=bbd39f62&scoped=true"
import script from "./form-employment.vue?vue&type=script&lang=js"
export * from "./form-employment.vue?vue&type=script&lang=js"
import style0 from "./form-employment.vue?vue&type=style&index=0&id=bbd39f62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd39f62",
  null
  
)

export default component.exports